import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import { RendererProps } from "../../../shared/renderers";
import { ExperimentEntity } from "../domain/experiment.entity";
import { messages } from "../experiment.messages";

type VariantTuple = ExperimentEntity["variants"];

const Container = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.3;
`;

const ScenarioALabel = styled.span`
  color: ${({ theme }) => theme.orangeBackground};
  font-weight: 600;
`;

const ScenarioBLabel = styled.span`
  color: ${({ theme }) => theme.darkBlueBackground};
  font-weight: 600;
`;

const VsLabel = styled.span`
  color: ${({ theme }) => theme.regularTextColor};
  font-size: 0.75rem;
`;

export function ScenarioVsCell({ value }: RendererProps<VariantTuple | undefined>) {
  if (!value || value.length < 2 || !value[0] || !value[1]) {
    return <>—</>;
  }
  const [variantA, variantB] = value;
  return (
    <Container>
      <ScenarioALabel>A: {variantA.ticker || "—"}</ScenarioALabel>
      <VsLabel>
        <FormattedMessage {...messages.common.vs} />
      </VsLabel>
      <ScenarioBLabel>B: {variantB.ticker || "—"}</ScenarioBLabel>
    </Container>
  );
}
